/*
 * TreatmentFlow Messages
 *
 * This contains all the text for the TreatmentFlow container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.TreatmentFlow";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the TreatmentFlow container!",
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: "Select treatment plan",
  },
  upperJaw: {
    id: `${scope}.upperJaw`,
    defaultMessage: "Upper Jaw",
  },
  bottomJaw: {
    id: `${scope}.bottomJaw`,
    defaultMessage: "Bottom Jaw",
  },
  dialogTitle: {
    id: `${scope}.dialogTitle`,
    defaultMessage: "Attention!",
  },
  extraConfirmation: {
    id: `${scope}.extraConfirmation`,
    defaultMessage:
      "By scheduling an extra treatment, the next appointment will automatically expire. You must then reschedule it after making the extra appointment. Are you sure you want to continue?",
  },
  confirm: {
    id: `${scope}.confirm`,
    defaultMessage: "Confirm",
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: "Cancel",
  },
  treatmentPhase: {
    id: `${scope}.treatmentPhase`,
    defaultMessage: "Treatment phase",
  },
  expectedDeliveryDate: {
    id: `${scope}.expectedDeliveryDate`,
    defaultMessage: "Expected delivery date",
  },
  productUpperJaw: {
    id: `${scope}.productUpperJaw`,
    defaultMessage: "Product upper jaw",
  },
  productLowerJaw: {
    id: `${scope}.productLowerJaw`,
    defaultMessage: "Product lower jaw",
  },
  previous: {
    id: `${scope}.previous`,
    defaultMessage: "Previous",
  },
  skip: {
    id: `${scope}.skip`,
    defaultMessage: "Skip order",
  },
  unknown: {
    id: `${scope}.unknown`,
    defaultMessage: "Unknown",
  },

  planExtraItem: {
    id: `${scope}.planExtraItem`,
    defaultMessage: "Plan extra treatment try-in",
  },

  cancelConfirmation: {
    id: `${scope}.cancelConfirmation`,
    defaultMessage: "Are you sure you want to cancel this order?",
  },
});
